import type { CustomerUI } from '@/types/ui/customers';

/** An account is active when its ERP status is Active. Accounts without an
 *  explicit status are treated as Active. On-stop accounts still count. */
export function isActiveCustomer(customer: Pick<CustomerUI, 'status'>): boolean {
  return (customer.status ?? 'Active') === 'Active';
}
